import { render, staticRenderFns } from "./MessageLayout.vue?vue&type=template&id=22732004&scoped=true&"
import script from "./MessageLayout.vue?vue&type=script&lang=js&"
export * from "./MessageLayout.vue?vue&type=script&lang=js&"
import style0 from "./MessageLayout.vue?vue&type=style&index=0&lang=css&"
import style1 from "./MessageLayout.vue?vue&type=style&index=1&id=22732004&scoped=true&lang=css&"
import style2 from "./MessageLayout.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22732004",
  null
  
)

export default component.exports